import { render } from "./Online.vue?vue&type=template&id=420eda5d"
import script from "./Online.vue?vue&type=script&lang=js"
export * from "./Online.vue?vue&type=script&lang=js"
script.render = render

export default script